import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Card, Heading3, Paragraph, Separator } from '@treams/treams-ui';

const Header = styled(Box)`
	overflow: hidden;
	position: relative;

	${Paragraph} {
		position: absolute;
		right: 10px;
		top: 2px;
	}
`;

const HeaderImage = styled(Flex)<{ logoCount: number }>`
	height: 120px;
	gap: 16px;

	img {
		max-height: 58px;
		max-width: ${(props) => (props.logoCount > 1 ? 56 : 140)}px;
		object-fit: contain;
		display: block;
		margin-top: 10px;
	}
`;

export default function ProductTile(
	props: {
		id: string;
		title: string;
		description: string;
		selected: boolean;
		price?: number;
	} & ({ logoImageURL: string } | { logoImageURLs: string[] }),
) {
	const logoImageURLs = 'logoImageURLs' in props ? props.logoImageURLs : [props.logoImageURL];

	return (
		<Card
			overflow="hidden"
			link={`/settings/integrations/${props.id}`}
			header={
				<>
					<Header py="1px" px={4}>
						<HeaderImage
							alignItems="center"
							justifyContent="center"
							logoCount={logoImageURLs.length}
						>
							{logoImageURLs.map((url) => (
								<img key={url} src={url} alt={logoImageURLs.length > 1 ? '' : props.title} />
							))}
						</HeaderImage>
					</Header>
					<Separator />
				</>
			}
			selected={props.selected}
		>
			<Flex justifyContent="space-between">
				<Heading3>{props.title}</Heading3>
			</Flex>
			<Paragraph>{props.description}</Paragraph>
		</Card>
	);
}
